exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app {\n  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  font-size: 0;\n  height: 100%;\n}", "", {"version":3,"sources":["/data/build-dir/13139969/AIC-YIWEXPER-JOB1/src/<input css 3>"],"names":[],"mappings":";AAAA;EACE,0DAA0D;EAC1D,oCAAoC;EACpC,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;CACd","file":"App.vue","sourcesContent":["#app {\n  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  font-size: 0;\n  height: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":true}!./node_modules/px2rem-loader?{"remUnit":100}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = miFK
// module chunks = 13